module.exports = __webpack_public_path__ + "img/l-cb6-010-2.c8cf8af7.gif";